export default function getComponent(component, to, href) {
    if (to || href) {
        return component || 'a';
    }
    return component || 'button';
}
//# sourceMappingURL=getComponent.js.map